import clsx, { type ClassValue } from 'clsx';

/** Tailwind class merger. Re-exported so consumers don't pull clsx directly. */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
